export class GenericError {
	title = ""
	message = ""
	message1 = ""
	constructor(title, message) {
		this.title = title
		this.message = message
		this.message1 = this.message1
	}
}
